import { HoveredPointTooltip } from './HoveredPointTooltip/HoveredPointTooltip.js';
import { useBarData } from '../../hooks/useBarData.js';
import type { BarSeriesWithDatapoints } from '../../types/xy-chart-internals.js';
import type { BarDatapoint } from '../../types/xy-chart.js';

export function BarSeriesTooltip({
  datapoint,
  series,
}: Readonly<{
  datapoint: BarDatapoint;
  series: BarSeriesWithDatapoints;
}>) {
  const { seriesToMetadata } = useBarData();

  return (
    <HoveredPointTooltip
      datapoint={datapoint}
      series={series}
      seriesToMetadata={seriesToMetadata}
    />
  );
}
